export var VERTEX_TYPE;
(function (VERTEX_TYPE) {
    VERTEX_TYPE["ROUND"] = "round";
    VERTEX_TYPE["STADIUM"] = "stadium";
    VERTEX_TYPE["DOUBLECIRCLE"] = "doublecircle";
    VERTEX_TYPE["CIRCLE"] = "circle";
    VERTEX_TYPE["DIAMOND"] = "diamond";
})(VERTEX_TYPE || (VERTEX_TYPE = {}));
export var LABEL_STYLE_PROPERTY;
(function (LABEL_STYLE_PROPERTY) {
    LABEL_STYLE_PROPERTY["COLOR"] = "color";
})(LABEL_STYLE_PROPERTY || (LABEL_STYLE_PROPERTY = {}));
export var CONTAINER_STYLE_PROPERTY;
(function (CONTAINER_STYLE_PROPERTY) {
    CONTAINER_STYLE_PROPERTY["FILL"] = "fill";
    CONTAINER_STYLE_PROPERTY["STROKE"] = "stroke";
    CONTAINER_STYLE_PROPERTY["STROKE_WIDTH"] = "stroke-width";
    CONTAINER_STYLE_PROPERTY["STROKE_DASHARRAY"] = "stroke-dasharray";
})(CONTAINER_STYLE_PROPERTY || (CONTAINER_STYLE_PROPERTY = {}));
